import type { Reducers } from "../../graph/types.ts";
import type { AssessmentNodes } from "../../types/assessment/data/index.ts";
import type { ResourceAggregates } from "../../types/assessment/data/resource.ts";
import { keyAggregate } from "./shared.ts";

export const resourceReducers: Reducers<AssessmentNodes, ResourceAggregates> = {
  grants: keyAggregate("grant"),
  identities: keyAggregate("identity"),
};
